import React from "react";
import "dayjs/locale/ru";
import dayjs from "dayjs";
import * as orderStatus from "../constants/status";

const deliveryStatus = {
  [orderStatus.DELIVERY_TAKEN]: "Принят водителем",
  [orderStatus.DELIVERY_AT_LOADING]: "На погрузке",
  [orderStatus.DELIVERY_ON_DISPATCH]: "В пути",
  [orderStatus.DELIVERY_REST_PARKING]: "На отдыхе",
  [orderStatus.DELIVERY_ARRIVED]: "Прибыл",
  [orderStatus.DELIVERY_ON_UNLOADING]: "На разгрузке",
  [orderStatus.DELIVERY_FINISHED]: "Завершён",
  [orderStatus.DELIVERY_FOR_LOADING]: "Едет на погрузку",
};

const OrderShort = ({
  order,
  profile,
  onlineDrivers,
  setShowOnMap,
  my = false,
  setLoading,
  fetchInitial,
}) => {
  let isActiveOrder = !!(
    order.status === orderStatus.ORDER_ACTIVE && order.driver
  );
  let onlineDriver = null;
  if (isActiveOrder && onlineDrivers) {
    onlineDriver = onlineDrivers.find((od) => od.id === order.driver.id);
  }

  if (order.offer) {
    isActiveOrder = true;
  }

  // console.log('profile', profile)

  // let image = null;

  // if (profile) {
  //   if (profile.company_profile && profile.company_profile.profile_images) {
  //     image = profile.company_profile.profile_images;
  //   } else if (profile.user.avatar) {
  //     image = profile.user.avatar;
  //   }
  // }

  return (
    <div className="transport">
      <div className="transport__wrapper">
        <div className="transport__driver pd-25">
          <div className="transport__date">
            <div className="transport__date__month">
              {dayjs(order.created_at).locale("ru").format("MMMM")}
            </div>
            <div className="transport__date__day">
              {dayjs(order.created_at).locale("ru").format("DD")}
            </div>
          </div>
          {/* <div className="transport__driver__media">
            <img src={image} alt="" />
          </div> */}
          <div className="transport__driver__info">
            <div className="transport__driver__info__id">ID {order.uuid}</div>
            <div className="transport__driver__info__name">
              {isActiveOrder || order.suggestion
                ? `${order.driver.last_name} ${order.driver.first_name}`
                : order.contacts.company_name || order.contacts.contact_name}
            </div>
          </div>
          {isActiveOrder && !order.offer && (
            <div className="transport__driver__status">
              {deliveryStatus[order.delivery_status]}
            </div>
          )}
          {!isActiveOrder && (
            <div className="transport__driver__rating">
              <div className="transport__driver__rating__icon" />
              <div className="transport__driver__rating">5.0</div>
              <div className="transport__driver__rating__comment-icon" />
              <div className="transport__driver__rating">0</div>
            </div>
          )}
        </div>
        <div className="transport__destinations pd-25">
          <div className="transport__destinations__left">
            {order.from_address.split(", ")[0] !== order.from_country && <div className="transport__destination__city">
              {order.from_address.split(", ")[0]}
            </div>}
            {order.from_address.split(", ")[0] === order.from_country && <div className="transport__destination__city">
              &nbsp;
            </div>}
            <div className="transport__destination__icon__wrapper transport__destination__icon__wrapper--from">
              <div className="transport__destination__icon transport__destination__icon--from">
                A
              </div>
            </div>
            <div className="transport__destination__country">
              <strong>{order.from_country_code}</strong>, {order.from_country}
            </div>
          </div>
          <div className="transport__destinations__middle">
            <div className="transport__destinations__middle__border" />
            <div className="transport__destinations__middle__distance">
              <div className="transport__destinations__middle__distance__icon" />
              {order.distance}
            </div>
          </div>
          <div className="transport__destinations__right">
            {order.to_address.split(", ")[0] !== order.to_country && <div className="transport__destination__city">
              {order.to_address.split(", ")[0]}
            </div>}
            {order.to_address.split(", ")[0] === order.to_country && <div className="transport__destination__city">
              &nbsp;
            </div>}
            <div className="transport__destination__icon__wrapper transport__destination__icon__wrapper--to">
              <div className="transport__destination__icon transport__destination__icon--to">
                B
              </div>
            </div>
            <div className="transport__destination__country">
              <strong>{order.to_country_code}</strong>, {order.to_country}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderShort;
